import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import Login from '../pages/login/page';
import Register from '../pages/register/page';
import ForgotPassword from '../pages/forgot-password/page';
import ResetPassword from '../pages/reset-password/page';
import Dashboard from '../pages/dashboard/page';
import DashboardAlertasKpis from '../pages/dashboard/alertas-kpis/page';
import DashboardCalendario from '../pages/dashboard/calendario/page';
import DashboardTreinamentos from '../pages/dashboard/treinamentos/page';
import SaudePendencias from '../pages/saude-pendencias/page';
import Condominios from '../pages/condominios/page';
import CondominioDetail from '../pages/condominios/detail/page';
import TorreDetail from '../pages/condominios/detail/torres/page';
import FuncionarioDetail from '../pages/condominios/detail/funcionarios/page';
import InfraItemDetail from '../pages/condominios/detail/infra/page';
import Prestadores from '../pages/prestadores/page';
import OrdensServico from '../pages/ordens-servico/page';
import GestaoPlano from '../pages/plan/page';
import Plano from '../pages/plan/plano/page';
import PlanoUsuarios from '../pages/plan/usuarios/page';
import PlanoCobrancas from '../pages/plan/cobrancas/page';
import Admin from '../pages/admin/page';
import AdminClientes from '../pages/admin/clientes/page';
import AdminClienteDetail from '../pages/admin/clientes/detail/page';
import AdminPlanos from '../pages/admin/planos/page';
import AdminFaturamentoRealizado from '../pages/admin/faturamento-realizado/page';
import AdminFaturamentoEstimado from '../pages/admin/faturamento-estimado/page';
import AdminNotificacoes from '../pages/admin/notificacoes/page';
import AdminAlvaras from '../pages/admin/alvaras/page';
import AdminProfissoes from '../pages/admin/profissoes/page';
import AdminInfraestrutura from '../pages/admin/infraestrutura/page';
import AdminAuditoria from '../pages/admin/auditoria/page';
import Profile from '../pages/profile/page';
import Ajuda from '../pages/ajuda/page';
import PlanGuard from '@/components/feature/PlanGuard';
import AceitarConvite from '../pages/aceitar-convite/page';
import VerificarEmail from '../pages/verificar-email/page';

const routes: RouteObject[] = [
  // ── Public routes (no auth, no plan required) ──
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/esqueci-senha',
    element: <ForgotPassword />,
  },
  {
    path: '/resetar-senha',
    element: <ResetPassword />,
  },
  {
    // Publica: quem aceita o convite ainda nao tem conta.
    path: '/aceitar-convite',
    element: <AceitarConvite />,
  },
  {
    // Publica: o link do e-mail costuma ser aberto em outro navegador, sem
    // sessao. O token e a prova de posse (ADR-0014).
    path: '/verificar-email',
    element: <VerificarEmail />,
  },

  // ── Protected routes (requires login + active plan) ──
  {
    element: <PlanGuard />,
    children: [
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/dashboard/alertas-kpis',
        element: <DashboardAlertasKpis />,
      },
      {
        path: '/dashboard/calendario',
        element: <DashboardCalendario />,
      },
      {
        path: '/dashboard/treinamentos',
        element: <DashboardTreinamentos />,
      },
      {
        path: '/saude-pendencias',
        element: <SaudePendencias />,
      },
      {
        path: '/prestadores',
        element: <Prestadores />,
      },
      {
        path: '/ordens-servico',
        element: <OrdensServico />,
      },
      {
        path: '/condominios',
        element: <Condominios />,
      },
      {
        path: '/condominios/:id',
        element: <CondominioDetail />,
      },
      {
        path: '/condominios/:id/:tab',
        element: <CondominioDetail />,
      },
      {
        path: '/condominios/:id/torres/:torreId',
        element: <TorreDetail />,
      },
      {
        path: '/condominios/:id/funcionarios/:funcionarioId',
        element: <FuncionarioDetail />,
      },
      {
        path: '/condominios/:id/infraestrutura/:itemId',
        element: <InfraItemDetail />,
      },
      {
        path: '/gestao-plano',
        element: <GestaoPlano />,
      },
      {
        path: '/gestao-plano/plano',
        element: <Plano />,
      },
      {
        path: '/gestao-plano/usuarios',
        element: <PlanoUsuarios />,
      },
      {
        path: '/gestao-plano/cobrancas',
        element: <PlanoCobrancas />,
      },
      {
        path: '/admin',
        element: <Admin />,
      },
      {
        path: '/admin/clientes',
        element: <AdminClientes />,
      },
      {
        path: '/admin/clientes/:id',
        element: <AdminClienteDetail />,
      },
      {
        path: '/admin/planos',
        element: <AdminPlanos />,
      },
      {
        path: '/admin/faturamento-realizado',
        element: <AdminFaturamentoRealizado />,
      },
      {
        path: '/admin/faturamento-estimado',
        element: <AdminFaturamentoEstimado />,
      },
      {
        path: '/admin/notificacoes',
        element: <AdminNotificacoes />,
      },
      {
        path: '/admin/alvaras',
        element: <AdminAlvaras />,
      },
      {
        path: '/admin/profissoes',
        element: <AdminProfissoes />,
      },
      {
        path: '/admin/infraestrutura',
        element: <AdminInfraestrutura />,
      },
      {
        path: '/admin/auditoria',
        element: <AdminAuditoria />,
      },
      {
        path: '/perfil',
        element: <Profile />,
      },
      {
        path: '/ajuda',
        element: <Ajuda />,
      },
    ],
  },

  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
